<div class="ionic ionic-example">
  <div class="bar bar-header bar-dark">
    <h1 class="title">{{'Management' | translate}} <ion-icon *ngIf="management.flatKey === 'ja'" name="key"></ion-icon></h1>
  </div>
</div>
<div>
  <ion-row>
    <ion-col text-bold>{{'CreateDate'| translate}}</ion-col>
    <ion-col>{{management.addDate | date:'dd.MM.yyyy HH:mm:ss'}}</ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'LocationGroup' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="management.locationDesc" [placeholder]="'LocationGroup' | translate" (modelDataOut)="management.locationDesc=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'RiskLevel' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="select" [options]="riskLevelOpt" [placeholder]="'RiskLevel' | translate" [modelData]="management.riskLevel" (modelDataOut)="management.riskLevel=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'ReferencePerson' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="management.contactPerson" [placeholder]="'ReferencePerson' | translate" (modelDataOut)="management.contactPerson=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'ContractType' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="select" [options]="optionContactType" [placeholder]="'ContractType' | translate" [modelData]="management.contractType" (modelDataOut)="management.contractType=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'SettlementType' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="select" [options]="optionBillingType" [placeholder]="'SettlementType' | translate" [modelData]="management.billingType" (modelDataOut)="management.billingType=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'ContractNumber' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="management.contractId" [placeholder]="'ContractNumber' | translate" (modelDataOut)="management.contractId=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'DeviceTpye' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="select" [options]="deviceTypeOpt" [placeholder]="'DeviceTpye' | translate" [modelData]="management.deviceType" (modelDataOut)="management.deviceType=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'RadioIdentification' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="text" [modelData]="management.radioReceiver | arraytostring" [placeholder]="'RadioIdentificationPlaceholder' | translate" (modelDataOut)="management.radioReceiver=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'DevicePhoneNumber' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="number" [modelData]="management.deviceFonNumber" [placeholder]="'DevicePhoneNumber' | translate" (modelDataOut)="management.deviceFonNumber=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'VoiceConnection' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="select" [options]="deviceCallOpt" [modelData]="management.deviceCall" [placeholder]="'VoiceConnectionPlaceholder' | translate" (modelDataOut)="management.deviceCall=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'KeyAvailable' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="select" [options]="deviceCallOpt" [modelData]="management.flatKey" [placeholder]="'KeyAvailable' | translate" (modelDataOut)="management.flatKey=$event"></edit-input></ion-col>
  </ion-row>
  <fieldset>
    <legend>{{'KeyComment' | translate}}</legend>
    <edit-input [isEdit]="isEdit" type="textarea" [modelData]="management.keyDesc" (modelDataOut)="management.keyDesc=$event"></edit-input>
  </fieldset>
  <ion-row>
    <ion-col text-bold>{{'PromRadio' | translate}}</ion-col>
    <ion-col>
      <edit-input [isEdit]="isEdit" [modelData]="transmitterId" [placeholder]="'PromRadio' | translate" [hasButton]="activeRadioListener" (textFieldButtonClick)="setRadioListener()" (modelDataOut)="changeTransMitterId($event)"></edit-input>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="isEdit">
      <ion-col text-bold>{{'Device' | translate}}</ion-col>
      <ion-col class="device-search">
        <ion-row>
            <ion-col size="10">
                <ion-searchbar [(ngModel)]="searchText" [placeholder]="'DevicePlaceholder' | translate"></ion-searchbar>
            </ion-col>
            <ion-col size="2">
                <ion-button [disabled]="!searchText" (click)="searchInventar()">
                  <ion-icon slot="icon-only" name="search"></ion-icon>
                </ion-button>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="findInventar">
          <ion-col size="12">
            <ion-button expand="block" [disabled]="!searchText" (click)="takeOverInventar()">{{'DataToInventory' | translate}}</ion-button>
          </ion-col>
        </ion-row>
    
      </ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold></ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="management.serienNr" placeholder="Geräte-Seriennummer" (modelDataOut)="management.serienNr=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row *ngIf="isEdit && address.firstname">
    <ion-col text-bold></ion-col>
    <ion-col>
        <app-neat-cmp [disabled]="!management.serienNr" [managementData]="{transmitterId:transmitterId, serienNr:management.serienNr, patientName:address.firstname+' '+address.lastname}" action="device-config"></app-neat-cmp>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'Terminated' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="select" [options]="optionTermination" [modelData]="management.termination" (modelDataOut)="management.termination=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row *ngIf="isEdit && management.serienNr">
    <ion-col text-bold></ion-col>
    <ion-col>
        <app-neat-cmp [disabled]="!management.serienNr" [managementData]="management" action="device-reset"></app-neat-cmp>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'TerminationDate' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="date" [modelData]="management.terminationDate" (modelDataOut)="management.terminationDate=$event"></edit-input></ion-col>
  </ion-row>
</div>
